// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3T7yM","errors":"Errors_errors__22Bud"};